import Action  from './baseActions';
import {Folder} from '../../models';

// Types

export enum FolderActionTypes {
  LOAD_FOLDERS = 'folder/load_folders',
  LOADING_FOLDERS = 'folder/loading_folders',
  LOADED_FOLDERS = 'folder/loaded_folders',
  LOADING_FOLDERS_FAILED = 'folder/loading_folders_failed',
  UNSET_FOLDERS = 'folder/unset_folders',

  CREATE_FOLDER = 'folder/create_folder',
  CREATING_FOLDER = 'folder/creating_folder',
  CREATED_FOLDER = 'folder/created_folder',
  CREATING_FOLDER_FAILED = 'folder/creating_folder_failed',

  UPDATE_FOLDER = 'folder/update_folder',
  UPDATING_FOLDER = 'folder/updating_folder',
  UPDATED_FOLDER = 'folder/updated_folder',
  UPDATING_FOLDER_FAILED = 'folder/updating_folder_failed',

  DELETE_FOLDER = 'folder/delete_folder',
  DELETING_FOLDER = 'folder/deleting_folder',
  DELETED_FOLDER = 'folder/deleted_folder',
  DELETING_FOLDER_FAILED = 'folder/deleting_folder_failed',
}

// Interfaces

export interface LoadFoldersAction extends Action {
  type: FolderActionTypes.LOAD_FOLDERS;
}

export interface LoadingFoldersAction extends Action {
  type: FolderActionTypes.LOADING_FOLDERS;
}

export interface LoadedFoldersAction extends Action {
  type: FolderActionTypes.LOADED_FOLDERS;
  payload: any;
}

export interface LoadingFoldersFailedAction extends Action {
  type: FolderActionTypes.LOADING_FOLDERS_FAILED;
}

export interface UnsetFoldersAction extends Action {
  type: FolderActionTypes.UNSET_FOLDERS;
}

export interface CreateFolderAction extends Action {
  type: FolderActionTypes.CREATE_FOLDER;
  payload: Partial<Folder>;
}

export interface CreatingFolderAction extends Action {
  type: FolderActionTypes.CREATING_FOLDER;
}

export interface CreatedFolderAction extends Action {
  type: FolderActionTypes.CREATED_FOLDER;
  payload: any;
}

export interface CreatingFolderFailedAction extends Action {
  type: FolderActionTypes.CREATING_FOLDER_FAILED;
}

export interface UpdateFolderAction extends Action {
  type: FolderActionTypes.UPDATE_FOLDER;
  payload: {
    uid: string;
    folder: Partial<Folder>;
  };
}

export interface UpdatingFolderAction extends Action {
  type: FolderActionTypes.UPDATING_FOLDER;
}

export interface UpdatedFolderAction extends Action {
  type: FolderActionTypes.UPDATED_FOLDER;
  payload: any;
}

export interface UpdatingFolderFailedAction extends Action {
  type: FolderActionTypes.UPDATING_FOLDER_FAILED;
}

export interface DeleteFolderAction extends Action {
  type: FolderActionTypes.DELETE_FOLDER;
  payload: string;
}

export interface DeletingFolderAction extends Action {
  type: FolderActionTypes.DELETING_FOLDER;
}

export interface DeletedFolderAction extends Action {
  type: FolderActionTypes.DELETED_FOLDER;
  payload: string;
}

export interface DeletingFolderFailedAction extends Action {
  type: FolderActionTypes.DELETING_FOLDER_FAILED;
}

// Functions

export function loadFolders(): LoadFoldersAction {
  return {
    type: FolderActionTypes.LOAD_FOLDERS,
  };
}

export function loadingFolders(): LoadingFoldersAction {
  return {
    type: FolderActionTypes.LOADING_FOLDERS,
  };
}

export function loadedFolders(result: any): LoadedFoldersAction {
  return {
    type: FolderActionTypes.LOADED_FOLDERS,
    payload: {
      result,
    },
  };
}

export function loadingFoldersFailed(): LoadingFoldersFailedAction {
  return {
    type: FolderActionTypes.LOADING_FOLDERS_FAILED,
  }
}

export function unsetFolders(): UnsetFoldersAction {
  return {
    type: FolderActionTypes.UNSET_FOLDERS,
  };
}

export function createFolder(folder: Partial<Folder>): CreateFolderAction {
  return {
    type: FolderActionTypes.CREATE_FOLDER,
    payload: folder,
  };
}

export function creatingFolder(): CreatingFolderAction {
  return {
    type: FolderActionTypes.CREATING_FOLDER,
  };
}

export function createdFolder(folder: any): CreatedFolderAction {
  return {
    type: FolderActionTypes.CREATED_FOLDER,
    payload: folder,
  };
}

export function creatingFolderFailed(): CreatingFolderFailedAction {
  return {
    type: FolderActionTypes.CREATING_FOLDER_FAILED,
  };
}

export function updateFolder(uid: string, folder: Partial<Folder>): UpdateFolderAction {
  return {
    type: FolderActionTypes.UPDATE_FOLDER,
    payload: {
      uid,
      folder,
    },
  };
}

export function updatingFolder(): UpdatingFolderAction {
  return {
    type: FolderActionTypes.UPDATING_FOLDER,
  };
}

export function updatedFolder(folder: any): UpdatedFolderAction {
  return {
    type: FolderActionTypes.UPDATED_FOLDER,
    payload: folder,
  };
}

export function updatingFolderFailed(): UpdatingFolderFailedAction {
  return {
    type: FolderActionTypes.UPDATING_FOLDER_FAILED,
  };
}

export function deleteFolder(uid: string): DeleteFolderAction {
  return {
    type: FolderActionTypes.DELETE_FOLDER,
    payload: uid,
  };
}

export function deletingFolder(): DeletingFolderAction {
  return {
    type: FolderActionTypes.DELETING_FOLDER,
  };
}

export function deletedFolder(uid: string): DeletedFolderAction {
  return {
    type: FolderActionTypes.DELETED_FOLDER,
    payload: uid,
  };
}

export function deletingFolderFailed(): DeletingFolderFailedAction {
  return {
    type: FolderActionTypes.DELETING_FOLDER_FAILED,
  };
}

// Types

export type FolderActions =
  | LoadFoldersAction
  | LoadingFoldersAction
  | LoadedFoldersAction
  | LoadingFoldersFailedAction
  | UnsetFoldersAction
  | CreateFolderAction
  | CreatingFolderAction
  | CreatedFolderAction
  | CreatingFolderFailedAction
  | UpdateFolderAction
  | UpdatingFolderAction
  | UpdatedFolderAction
  | UpdatingFolderFailedAction
  | DeleteFolderAction
  | DeletingFolderAction
  | DeletedFolderAction
  | DeletingFolderFailedAction;
